import type { Regions } from './countries-by-region';
import type { Subregions } from './countries-by-sub-region';
import { SUBREGIONS_BY_REGION } from './subregions-by-region';

export type RegionsAndSubregions = Regions | Subregions;

export const REGIONS_AND_SUBREGIONS = Object
	.entries(SUBREGIONS_BY_REGION)
	.flatMap(([ region, subregions ]) => [ region, ...subregions ]);
